/* unplugin-vue-components disabled */import script from "./CWA.vue?vue&type=script&setup=true&lang=js"
export * from "./CWA.vue?vue&type=script&setup=true&lang=js"

import "./CWA.vue?vue&type=style&index=0&id=561e0c0b&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-561e0c0b"]])

export default __exports__